<h2 mat-dialog-title>{{ 'filterSelectDialog.title' | translate }}</h2>
<mat-dialog-content class="form-container" fxLayout="row" fxLayoutAlign="center start">
  <div class="form-contents" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">

    <div class="serial-content" fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="10px">

      <!-- Own Check box -->
      <div class="checkbox">
        <mat-checkbox  [(ngModel)]="own.selectedValue"
          (change)="changeValue(own.contentId, $event.checked)">{{own.placeholder}}</mat-checkbox>
      </div>

      <!-- Selected Only Check box -->
      <div class="checkbox" *ngIf="selectedOnly">
        <mat-checkbox [(ngModel)]="selectedOnly.selectedValue"
          (change)="changeValue(selectedOnly.contentId, $event.checked)">{{selectedOnly.placeholder}}</mat-checkbox>
      </div>

      <!-- Status -->
      <app-search-combo-box [width]="240" [placeholder]="status.placeholder" [options]="status.options" [selectedId]="status.selectedValue"
        (changedValue)="changeValue(status.contentId, $event)">
      </app-search-combo-box>

      <!-- Subject Model -->
      <app-search-combo-box [width]="240" [placeholder]="subjectModel.placeholder" [options]="subjectModel.options" [selectedId]="subjectModel.selectedValue"
        (changedValue)="changeValue(subjectModel.contentId, $event)">
      </app-search-combo-box>

      <!-- Serial Number -->
      <app-search-combo-box [width]="240" [placeholder]="subject.placeholder" [options]="subject.options" [selectedId]="subject.selectedValue"
        (changedValue)="changeValue(subject.contentId, $event)">
      </app-search-combo-box>

    </div>

    <div fxLayout="row wrap" *ngIf="!isHide(ownerKey)" class="parse-line" fxLayoutAlign="start" fxLayoutGap="10px">
        <!-- Owner -->
        <app-search-combo-box *ngIf="!isHide(ownerKey)" [width]="240" [placeholder]="owner.placeholder" [options]="owner.options" [selectedId]="owner.selectedValue"
          (changedValue)="changeValue(owner.contentId, $event)">
        </app-search-combo-box>
    </div>

    <div fxLayout="row wrap" *ngIf="!isHide(countryKey) || !isHide(stateKey) || !isHide(districtKey)" fxLayoutAlign="start" fxLayoutGap="10px"
        [class.parse-line]="isHide(ownerKey)">
        <!-- Country -->
        <app-search-combo-box *ngIf="!isHide(countryKey)" [width]="240" [placeholder]="country.placeholder"
          [options]="country.options" [selectedId]="country.selectedValue"
          (changedValue)="changeValue(country.contentId, $event)">
        </app-search-combo-box>

        <!-- State -->
        <app-search-combo-box *ngIf="!isHide(stateKey)" [width]="240" [placeholder]="state.placeholder"
          [options]="state.options" [selectedId]="state.selectedValue"
          (changedValue)="changeValue(state.contentId, $event)">
        </app-search-combo-box>

        <!-- District -->
        <app-search-combo-box *ngIf="!isHide(districtKey)" [width]="240" [placeholder]="district.placeholder"
          [options]="district.options" [selectedId]="district.selectedValue"
          (changedValue)="changeValue(district.contentId, $event)">
        </app-search-combo-box>
    </div>

    <div fxLayout="row wrap" *ngIf="!isHide(siteKey) || !isHide(projectKey)" fxLayoutAlign="start" fxLayoutGap="10px"
        [class.parse-line]="isHide(ownerKey) && isHide(countryKey) && isHide(stateKey) && isHide(districtKey)">
        <!-- Site -->
        <app-search-combo-box *ngIf="!isHide(siteKey)" [width]="240" [placeholder]="site.placeholder"
          [options]="site.options" [selectedId]="site.selectedValue"
          (changedValue)="changeValue(site.contentId, $event)">
        </app-search-combo-box>

        <!-- Project -->
        <app-search-combo-box *ngIf="!isHide(projectKey)" [width]="240" [placeholder]="project.placeholder"
          [options]="project.options" [selectedId]="project.selectedValue"
          (changedValue)="changeValue(project.contentId, $event)">
        </app-search-combo-box>
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutGap="10px">
    <div fxFlex fxLayout="row" fxLayoutAlign="center">
      <button mat-button color="primary" [mat-dialog-close]="true">
        {{ 'filterSelectDialog.cancel' | translate }}
      </button>
      <button mat-raised-button [disabled]="false" color="primary" (click)="apply()">
        {{ 'filterSelectDialog.apply' | translate }}
      </button>
    </div>
    <button mat-raised-button color="warn" (click)="clear()" [disabled]="false">
      {{ 'filterSelectDialog.clear' | translate }}
    </button>
</mat-dialog-actions>
